// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Triggers.scss
// module id = 679
// module chunks = 59 88